export default "__VITE_ASSET__D73rG0Cy__"